module.exports = __webpack_public_path__ + "static/media/Good.521ef1c9.png";